<template>
  <div id="app">
    <export_filter />
    <!--    <navbar />-->
    <router-view :key="$route.fullPath" />
    <mainFooter />
  </div>
</template>
<script>
import mainFooter from "@/components/mainfooter";
import export_filter from "@/components/export_filter";
import Swal from "sweetalert2";

export default {
  components: {
    // navbar,
    mainFooter,
    export_filter,
  },
  // created() {
    // Swal.fire({
    //   title: '<div class="text-error">มีบางอย่างผิดพลาด!</div> ',
    //   html: `<div class="text-dark"> การบันทึกข้อมูลการสำรวจของคุณไม่สำเร็จ กรุณาเพิ่มข้อมูล หรือ ตรวจสอบการเชื่อมต่ออินเตอร์เน็ต</div>`,
    //   background: `#fff url(${require('../src/assets/icons/icon_sweet_alert/background.png')}) no-repeat center center`,
    //   imageUrl: require('../src/assets/icons/icon_sweet_alert/error.png'),
    //   imageAlt: "Error",
    //   confirmButtonText:"ยืนยัน",
    //   customClass: {
    // 	  confirmButton: 'cancel-btn pill' //insert class here
    //   }
    // });
  // },
};
</script>
<style>
html,

body {
  overflow-x: hidden;
  height: 100%;
  min-height: 100vh;
}
body {
  position: relative;
}
</style>
